import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type GenericCarNameClasses = 'modelName' | 'variantName';

const genericCarNameStyles = makeStyles<ISpcTheme, GenericCarNameClasses>(
  () => ({
    modelName: {
      paddingRight: '4px',
    },
    variantName: {},
  }),
  { name: 'PVariants_GenericCarName' },
);

export default genericCarNameStyles;
